import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38333929"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "signup-form__title" }, " Создать аккаунт ", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "signup-form__text" }, " Email ", -1 /* HOISTED */))
const _hoisted_4 = { class: "email-error-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "signup-form__text" }, " Ник ", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "signup-form__text" }, " Пароль ", -1 /* HOISTED */))
const _hoisted_7 = { class: "email-error-text" }
const _hoisted_8 = { class: "signup-form__help" }

import pCheckbox from '../../common/pCheckbox/pCheckbox.vue'
import pButton from '../../common/pButton/pButton.vue'
import pInput from '../../common/pInput/pInput.vue'
import { useAuthPopup } from './../store/authPopup'
import api from "../api/api";
import SignUpData from "../types/SignUpData";
import {Ref, ref} from "vue";
import AgreementSignUp from "@/authSection/types/AgreementSignUp";
import {debounce} from "lodash";
import {AxiosError} from "axios";
import {useClientStore} from "@/authSection/store/clientStore";
import {ValidationSignUpErrorText} from "@/authSection/types/ValidationSignUpErrorText";
import ValidationException from "@/authSection/types/ValidationException";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpForm',
  setup(__props) {

const authPopupStore = useAuthPopup()
const clientStore = useClientStore()
const signUpData: Ref<SignUpData> = ref({
  email: '',
  password: '',
  name: '',
})
const agreement: Ref<AgreementSignUp> = ref({
  years: true,
})
const emailIsValid: Ref<boolean> = ref(true)
const emailErrorText: Ref<string> = ref('')

const passwordIsValid: Ref<boolean> = ref(true)
const passwordErrorText: Ref<string> = ref('')

function setEmail(event: Event) {
  signUpData.value.email = (event.target as HTMLInputElement).value
}

const checkEmail = debounce(async () => {
  try {
    await api.checkEmail(signUpData.value.email)
    emailErrorText.value = ''
    emailIsValid.value = true
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      if (e.response?.status === 400) {
        emailIsValid.value = false
        emailErrorText.value = e.response.data.error
      }
    }
  }
}, 500)

const checkPassword = debounce(async () => {
  if (signUpData.value.password.length < 6) {
    passwordErrorText.value = 'Пароль должен быть больше 6 символов'
    return passwordIsValid.value = false
  }
  passwordErrorText.value = ''
  passwordIsValid.value = true
}, 500)

function validateSignUpForm() {
  if (signUpData.value.email.length === 0) {
    throw new ValidationException(ValidationSignUpErrorText.EMAIL_IS_EMPTY)
  }

  if (!emailIsValid.value) {
    throw new ValidationException(ValidationSignUpErrorText.EMAIL_IS_INVALID)
  }

  if (signUpData.value.name.length === 0) {
    throw new ValidationException(ValidationSignUpErrorText.NAME_IS_EMPTY)
  }

  if (signUpData.value.password.length === 0) {
    throw new ValidationException(ValidationSignUpErrorText.PASSWORD_IS_EMPTY)
  }

  if (!passwordIsValid.value) {
    throw new ValidationException(ValidationSignUpErrorText.PASSWORD_IS_INVALID)
  }

  if (!agreement.value.years) {
    throw new ValidationException(ValidationSignUpErrorText.YEARS_AGREEMENT)
  }
}

async function sendRequest() {
  try {
    validateSignUpForm()
  } catch (error: any) {
    if (error instanceof ValidationException) {
      return window.showNotification(error.message, 'warning')
    }
  }

  try {
    await api.createClient({
      ...signUpData.value,
    })
    authPopupStore.visible = false
    clientStore.isAuth = true
  } catch (e: unknown) {
    window.showNotification('Произошла ошибка!', 'error')
    console.log(e)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(pInput, {
      name: "email",
      value: signUpData.value.email,
      valid: emailIsValid.value,
      placeholder: 'Введите вашу почту',
      onInput: setEmail,
      onKeyup: _unref(checkEmail)
    }, null, 8 /* PROPS */, ["value", "valid", "onKeyup"]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(emailErrorText.value), 1 /* TEXT */),
    _hoisted_5,
    _createVNode(pInput, {
      value: signUpData.value.name,
      placeholder: 'Придумайте ник',
      onInput: _cache[0] || (_cache[0] = ($event: any) => (signUpData.value.name = $event.target.value))
    }, null, 8 /* PROPS */, ["value"]),
    _hoisted_6,
    _createVNode(pInput, {
      value: signUpData.value.password,
      placeholder: 'Придумайте пароль',
      type: "password",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (signUpData.value.password = $event.target.value)),
      onKeyup: _unref(checkPassword)
    }, null, 8 /* PROPS */, ["value", "onKeyup"]),
    _createElementVNode("span", _hoisted_7, _toDisplayString(passwordErrorText.value), 1 /* TEXT */),
    _createVNode(pCheckbox, {
      modelValue: agreement.value.years,
      class: "signup-form__checkbox",
      label: 'Я подтверждаю, что мне исполнилось 18 лет, и я принимаю пользовательское соглашение.',
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (agreement.value.years = !agreement.value.years))
    }, null, 8 /* PROPS */, ["modelValue", "label"]),
    _createVNode(pButton, {
      class: "signup-form__sign",
      onClick: sendRequest
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Зарегистрироваться ")
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("span", _hoisted_8, [
      _createTextVNode(" Уже есть на аккаунт? "),
      _createElementVNode("span", {
        class: "signup-form__signup",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(authPopupStore).openSignForm && _unref(authPopupStore).openSignForm(...args)))
      }, "Войти")
    ])
  ]))
}
}

})